import createDisplayName from "../../../../fabrics/createDisplayName";
import { HEADER_CLOSE_DISPLAY_NAME } from "../HeaderClose";

export const createDisplayNameForHeaderClose = createDisplayName(
    HEADER_CLOSE_DISPLAY_NAME,
);
